import { ResponseError } from '../resolver/types';

export default function getResponseErrors({
  error,
  setErrorList,
}: {
  error?: ResponseError;
  setErrorList: (data: string) => void;
}) {
  if (error) {
    if (error?.data?.error) {
      if (typeof error?.data?.error === 'string' && !error?.data?.message) {
        setErrorList(error?.data?.error);
      } else if (
        error?.data?.message &&
        typeof error?.data?.message === 'string'
      ) {
        setErrorList(error?.data?.message);
      } else if (error?.data?.message && Array.isArray(error?.data?.message)) {
        const messages: string[] = [];

        error?.data?.message?.forEach((item) => {
          messages.push(item.value as string);
        });

        setErrorList(messages?.join(', '));
      } else {
        setErrorList('Internal Server Error. Try again.');
      }
    } else if (error?.status === 500) {
      setErrorList('Internal Server Error. Try again.');
    }
  }
}
